export default "__VITE_ASSET__CKGrOX_y__"